// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__sRwa0"};